import { DefineEntity, Entity2D, EntityType, Vector2 } from '../../../odie';
import { GameScene } from '../../GameScene';
import { BlockComponent } from '../../components/BlockComponent';
import { PositionComponent } from '../../components/PositionComponent';
import { BlockProps } from '../../defs/block';
import { BlockDef } from '../../defs/map';
import { _spawnBaseBlockEntity } from '../../entities/BlockEntity';
import { BigEggBlockComponent } from './BigEggBlockComponent';
import { BigEggBlockProps } from './BigEggBlock';

const BigEggBlockEntityDef = DefineEntity(
  Entity2D,
  PositionComponent,
  BlockComponent,
  BigEggBlockComponent,
);
export type BigEggBlockEntity = EntityType<typeof BigEggBlockEntityDef>;

export function _spawnBigEggBlockEntity(
  scene: GameScene,
  def: BlockDef,
  props: BlockProps,
  position: Vector2,
): BigEggBlockEntity {
  // spawn base block
  const entity = _spawnBaseBlockEntity(
    BigEggBlockEntityDef,
    scene,
    def.id,
    props,
    position,
    {
      blockBigEgg: {
        props: props as BigEggBlockProps,
        option: def.option,
      },
    },
  );

  // build scene
  entity.c.view2d.view.addChild(entity.c.blockBigEgg.view);

  return entity;
}
